<div class="row">
  <div class="col-12">
    <div class="input-group float-end align-items-center w-40">
      <input type="text" class="form-control sombra"
        [value]="campoInput"
        (input)="onInput($any($event.target).value)"
        (keyup.enter)="buscar.emit()"
        [placeholder]="placeholder"
        [tag]="tagBuscar">
      <button class="btn-icon" (click)="buscar.emit()">
        <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
      </button>
      @if (buscaFiltrada) {
        <button class="botao-outline" (click)="limpar.emit()" [tag]="tagLimpar">LIMPAR FILTRO</button>
      }
    </div>
  </div>
</div>
